/* eslint-disable no-magic-numbers */
/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-useless-return */
/* eslint-disable max-depth */
/* eslint-disable prefer-template */
/* eslint-disable no-return-assign */
/* eslint-disable prefer-const */
/* eslint-disable max-lines */
/* eslint-disable @typescript-eslint/prefer-for-of */
/* eslint-disable max-lines-per-function */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable no-unused-expressions */
/* eslint-disable complexity */
/* eslint-disable @typescript-eslint/prefer-optional-chain */
/* eslint-disable no-var */
/* eslint-disable eqeqeq */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable max-params */
/* eslint-disable @typescript-eslint/array-type */
/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-member-accessibility */
import { Component, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ChatContent } from '../../models/chat.model';

/**
 * Content Renderer Component
 * 
 * Renders chat message content with optional word-by-word streaming animation.
 * Supports various content types: text, markdown, code, tables, and lists.
 * 
 * @example
 * <app-content-renderer 
 *   [content]="messageContent"
 *   [isBotMessage]="true"
 *   [enableStreaming]="true"
 *   [streamingSpeed]="50">
 * </app-content-renderer>
 */
@Component({
    selector: 'app-content-renderer',
    templateUrl: './content-renderer.component.html',
    styleUrls: ['./content-renderer.component.scss'],
    standalone: false
})
export class ContentRendererComponent implements OnChanges, OnDestroy {
    /** Content object to render */
    @Input() content!: ChatContent;

    /** Enable/disable streaming animation */
    @Input() enableStreaming: boolean = true;

    /** Controls if chat-level streaming is enabled */
    @Input() enableChatStreaming: boolean = false;

    /** Speed of word streaming in milliseconds */
    @Input() streamingSpeed: number = 50;

    /** Identifies if this is a bot message (for streaming logic) */
    @Input() isBotMessage: boolean = false;

    /** Currently displayed text during streaming */
    displayedText: string = '';

    /** Indicates if streaming is currently active */
    isStreaming: boolean = false;

    /** Indicates if streaming has completed */
    streamingComplete: boolean = false;

    /** Timeout reference for streaming animation */
    private streamingTimeout: any;

    /** Current word index during streaming */
    private currentWordIndex: number = 0;

    /** Full text before streaming */
    private fullText: string = '';

    /** Array of words to stream */
    private words: string[] = [];

    constructor(private sanitizer: DomSanitizer) { }

    /**
     * Handle input property changes
     * Reinitializes streaming when content changes
     * 
     * @param changes - Changed properties
     */
    ngOnChanges(changes: SimpleChanges): void {
        if (changes['content'] && this.content) {
            this.initializeStreaming();
        }
    }

    /**
     * Cleanup on component destroy
     * Stops any active streaming
     */
    ngOnDestroy(): void {
        this.stopStreaming();
    }

    /**
     * Initialize word-by-word streaming display for bot messages
     */
    private initializeStreaming(): void {
        // Only apply streaming for bot messages, not user messages
        const shouldStream = this.enableStreaming &&
            this.isBotMessage && this.enableChatStreaming &&
            this.content &&
            (this.content.type === 'text' || this.content.type === 'markdown' || this.content.type === 'code');

        if (!shouldStream) {
            this.displayedText = this.getContentText();
            this.streamingComplete = true;
            return;
        }

        this.stopStreaming();
        this.fullText = this.getContentText();
        this.words = this.splitIntoWords(this.fullText);
        this.displayedText = '';
        this.currentWordIndex = 0;
        this.isStreaming = true;
        this.streamingComplete = false;
        this.startStreaming();
    }

    /**
     * Start word-by-word streaming
     */
    private startStreaming(): void {
        if (this.currentWordIndex < this.words.length) {
            // Add space before word (except for the first word)
            if (this.currentWordIndex > 0) {
                this.displayedText += ' ';
            }

            this.displayedText += this.words[this.currentWordIndex];
            this.currentWordIndex++;

            this.streamingTimeout = setTimeout(() => {
                this.startStreaming();
            }, this.streamingSpeed);
        } else {
            this.completeStreaming();
        }
    }

    /**
     * Complete streaming display
     */
    private completeStreaming(): void {
        this.isStreaming = false;
        this.streamingComplete = true;
        this.displayedText = this.fullText;
    }

    /**
     * Stop current streaming process
     */
    private stopStreaming(): void {
        if (this.streamingTimeout) {
            clearTimeout(this.streamingTimeout);
            this.streamingTimeout = null;
        }
        this.isStreaming = false;
    }

    /**
     * Get text content for streaming
     */
    private getContentText(): string {
        if (!this.content) return '';

        switch (this.content.type) {
            case 'text':
            case 'markdown':
                return this.content.data || '';
            case 'code':
                return this.content.data || '';
            default:
                return '';
        }
    }

    /**
     * Split text into words while preserving line breaks and formatting
     */
    private splitIntoWords(text: string): string[] {
        if (!text) return [];

        // Simple word splitting that preserves punctuation with words
        return text.split(/\s+/).filter(word => word.length > 0);
    }

    /**
     * Check if streaming should be applied for current content
     */
    shouldApplyStreaming(): boolean {
        return this.enableStreaming &&
            this.isBotMessage &&
            this.content &&
            (this.content.type === 'text' || this.content.type === 'markdown' || this.content.type === 'code');
    }

    /**
     * Check if data is in table format
     * @param data - Data to check
     * @returns True if data has table structure
     */
    isTableData(data: any): boolean {
        return data && typeof data === 'object' && data.headers && data.rows;
    }

    /**
     * Check if data is in list format
     * @param data - Data to check
     * @returns True if data has list structure
     */
    isListData(data: any): boolean {
        return data && typeof data === 'object' && data.items && Array.isArray(data.items);
    }

    /**
     * Format text with markdown-like syntax
     * Converts **bold**, *italic*, `code`, and newlines to HTML
     * 
     * @param text - Text to format
     * @returns Formatted HTML string
     */
    formatText(text: string): string {
        if (!text) return '';

        // Check if text contains HTML table tags
        if (text.includes('<table') && text.includes('</table>')) {
            // Return HTML as-is for tables
            return text;
        }

        // Simple markdown-like formatting for regular text
        return text
            .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>') // Bold
            .replace(/\*(.*?)\*/g, '<em>$1</em>') // Italic
            .replace(/`(.*?)`/g, '<code>$1</code>') // Inline code
            .replace(/\n/g, '<br>'); // Line breaks
    }

    /**
     * Copy text to clipboard
     * Uses modern Clipboard API if available
     * 
     * @param text - Text to copy
     */
    copyToClipboard(text: string): void {
        if (navigator.clipboard) {
            navigator.clipboard.writeText(text).then(() => {
                // Could show a toast notification here
                console.log('Copied to clipboard');
            }).catch(err => {
                console.error('Failed to copy: ', err);
            });
        }
    }

    /**
     * Safely sanitize HTML content for rendering
     */
    getSafeHtml(htmlContent: string): SafeHtml {
        return this.sanitizer.bypassSecurityTrustHtml(htmlContent);
    }

    /**
     * Additional methods for table rendering support
     */
    getTableDataSource(): any[] {
        if (!this.isTableData(this.content.data)) return [];

        return this.content.data.rows.map((row: string[]) => {
            const rowObj: any = {};
            this.content.data.headers.forEach((header: string, index: number) => {
                rowObj[`col_${index}`] = row[index] || '';
            });
            return rowObj;
        });
    }

    getTableColumns(): string[] {
        if (!this.isTableData(this.content.data)) return [];

        return this.content.data.headers.map((_: string, index: number) => `col_${index}`);
    }

    getTableAsText(): string {
        if (!this.isTableData(this.content.data)) return '';

        const headerRow = this.content.data.headers.join('\t');
        const dataRows = this.content.data.rows.map((row: string[]) => row.join('\t'));
        return [headerRow, ...dataRows].join('\n');
    }
}